import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Table } from "reactstrap";
import { Bar } from "react-chartjs-2";
import moment from "moment";

import authActions from "../../redux/auth/action";
import historyActions from "../../redux/history/action";
import dashboardActions from "../../redux/dashboard/action";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import {
  formatNumbers,
  isNetworkRequestFailedError,
} from "../../config/helpers";
import api from "../../config/api";
import PageHead from "../../component/pageHead/PageHead";
import "./style.css";
import FloatingButton from "../../component/FloatingButton";

class MemberDashboard extends Component {
  state = {
    data: null,
    isLoading: false,
  };

  componentDidMount() {
    const { user, data } = this.props;

    if (user && !data) {
      this.fetchData(user);
    }
    if (data) {
      this.prepareGraph(data);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { data: prevData } = this.props;
    const { data: nextData } = nextProps;

    if (!this.props.user && nextProps.user && !prevData) {
      this.fetchData(nextProps.user);
    }
    if (JSON.stringify(prevData) !== JSON.stringify(nextData)) {
      setTimeout(() => this.prepareGraph(nextData), 500);
    }
  }

  prepareGraph = (data) => {
    const ctx = document.getElementById("canvas").getContext("2d");
    const gradientPurple = ctx.createLinearGradient(0, 0, 0, 100);
    gradientPurple.addColorStop(0, "#32385f");
    gradientPurple.addColorStop(1, "#51608b");

    const gradientBlue = ctx.createLinearGradient(0, 0, 0, 100);
    gradientBlue.addColorStop(0, "#336cad");
    gradientBlue.addColorStop(1, "#3a73b0");

    const gradientGreen = ctx.createLinearGradient(0, 0, 0, 100);
    gradientGreen.addColorStop(0, "#7da009");
    gradientGreen.addColorStop(1, "#9dcb1e");

    const gradientOrange = ctx.createLinearGradient(0, 0, 0, 100);
    gradientOrange.addColorStop(0, "#fab00f");
    gradientOrange.addColorStop(1, "#fa8b1a");

    const gradientDarkGreen = ctx.createLinearGradient(0, 0, 0, 100);
    gradientDarkGreen.addColorStop(0, "#3a7f5a");
    gradientDarkGreen.addColorStop(1, "#66a97a");

    const gradientLightGreen = ctx.createLinearGradient(0, 0, 0, 100);
    gradientLightGreen.addColorStop(0, "#53bc63");
    gradientLightGreen.addColorStop(1, "#29af66");

    this.data = {
      labels: [
        ["Mandatory", "Contib"],
        ["Mandatory", "Contib Growth"],
        ["Voluntary", "Contrib"],
        ["Voluntary", "Contrib Growth"],
        ["Total", "Contribution"],
        ["Current", "Balance"],
      ],
      datasets: [
        {
          backgroundColor: [
            gradientPurple,
            gradientBlue,
            gradientGreen,
            gradientOrange,
            gradientDarkGreen,
            gradientLightGreen,
          ],
          data: [
            data.ManContr,
            data.ManGrowth,
            data.VolContr,
            data.VolGrowth,
            data.totContr,
            data.totBal,
          ],
        },
      ],
    };

    this.setState({});
  };

  fetchData = async (user) => {
    let currentPrice;
    let fundName;

    const { setAlertMessage, setMemberDashboardValues } = this.props;
    this.setState({ isLoading: true });

    try {
      const body = {
        pin: user.User.rsaPin,
        endDate: moment().format("YYYY-MMMM-DD"),
      };

      const promises = [api.allMemberBalance(body, user.token)];

      if (user.profile)
        promises.push(
          api.fetchCurrentPrice({ fundId: user.profile.FundID }, user.token)
        );

      const responsesArr = await Promise.all(promises);

      if (responsesArr[1]) {
        currentPrice = responsesArr[1].data.result.UnitPrice;
        fundName = responsesArr[1].data.result.FundName;
      }

      if (responsesArr[0].data.result.length) {
        this.setState(
          {
            data: responsesArr[0].data.result[0],
            currentPrice,
          }
          // () => this.prepareGraph(responsesArr[0].data.result[0])
        );
        setMemberDashboardValues({
          data: responsesArr[0].data.result[0],
          currentPrice,
          fundName,
        });
      } else {
        this.setState({ data: null });
      }
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? () => this.fetchData(user)
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  navigateToReferral = () => {
    this.props.history.push("/referral");
  };

  render() {
    const { isLoading } = this.state;
    const { data, currentPrice, fundName } = this.props;

    return data ? (
      <Container>
        <div className="mt-3 member-dashboard-main-graph-container">
          <div className="member-dashboard-graph-header pt-0 my-1">
            <p>Current Balance</p>
            <p>
              <span className="mx-2">₦</span>
              <span>{formatNumbers(data.totBal, true)}</span>
            </p>
          </div>
          <div className="member-dashboard-graph-container">
            <Bar
              id="canvas"
              data={this.data || {}}
              width={100}
              height={200}
              options={{
                maintainAspectRatio: false,
                tooltips: {
                  callbacks: {
                    label: function (tooltipItem, data) {
                      return formatNumbers(tooltipItem.value);
                    },
                  },
                },
                legend: {
                  display: false,
                },
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        maxTicksLimit: 6,
                        callback: (label) => formatNumbers(label, true),
                      },
                    },
                  ],
                  xAxes: [
                    {
                      barPercentage: 0.6,
                      gridLines: {
                        display: false,
                        color: "rgba(0,0,0,0.4)",
                        lineWidth: 2,
                      },
                      ticks: {
                        fontStyle: "bold",
                        fontSize: 8,
                        fontColor: "blue",
                      },
                    },
                  ],
                },
              }}
            />
          </div>
        </div>
        <PageHead
          leftText={fundName}
          rightText={`Current Price ${currentPrice}`}
          containerStyles={{ width: "100%" }}
        />
        <Table className="member-dashboard-table my-2" size="sm" bordered>
          <thead />
          <tbody>
            <tr>
              <th className="member-dashboard-table-cell">Description</th>
              <td className="member-dashboard-table-cell" />
              <td className="member-dashboard-table-cell text-right">Amount</td>
            </tr>
            <tr>
              <th rowSpan="2" className="member-dashboard-table-cell">
                Contribution Amount
              </th>
              <td className="member-dashboard-table-cell">Mandatory</td>
              <td className="member-dashboard-table-cell text-right">
                <span>₦</span>
                {formatNumbers(data.ManContr, true)}
              </td>
            </tr>
            <tr>
              <td className="member-dashboard-table-cell">Voluntary</td>
              <td className="member-dashboard-table-cell text-right">
                <span>₦</span>
                {formatNumbers(data.VolContr, true)}
              </td>
            </tr>
            <tr>
              <th rowSpan="2" className="member-dashboard-table-cell">
                Gain/Loss
              </th>
              <td className="member-dashboard-table-cell">Mandatory</td>
              <td className="member-dashboard-table-cell text-right">
                <span>₦</span>
                {formatNumbers(data.ManGrowth, true)}
              </td>
            </tr>
            <tr>
              <td className="member-dashboard-table-cell">Voluntary</td>
              <td className="member-dashboard-table-cell text-right">
                <span>₦</span>
                {formatNumbers(data.VolGrowth, true)}
              </td>
            </tr>
            <tr>
              <th className="member-dashboard-table-cell">Total Refunds</th>
              <td className="member-dashboard-table-cell" />
              <td className="member-dashboard-table-cell text-right">
                <span>₦</span>
                {formatNumbers(data.Refunds, true)}
              </td>
            </tr>
            <tr>
              <th className="member-dashboard-table-cell">Total Withdrawals</th>
              <td className="member-dashboard-table-cell" />
              <td className="member-dashboard-table-cell text-right">
                <span>₦</span>
                {formatNumbers(data.totWtdr, true)}
              </td>
            </tr>
            <tr>
              <th className="member-dashboard-table-cell">Total Gain/Loss</th>
              <td className="member-dashboard-table-cell" />
              <td className="member-dashboard-table-cell text-right">
                <span>₦</span>
                {formatNumbers(data.totGrowth, true)}
              </td>
            </tr>
            <tr>
              <th className="member-dashboard-table-cell">Current Balance</th>
              <td className="member-dashboard-table-cell" />
              <td className="member-dashboard-table-cell text-right">
                <span>₦</span>
                {formatNumbers(data.totBal, true)}
              </td>
            </tr>
          </tbody>
        </Table>
        <FloatingButton
          onClick={this.navigateToReferral}
          style={{ position: "absolute" }}
          position="BOTTOM_CENTER"
        >
          Referral
        </FloatingButton>
      </Container>
    ) : (
      isLoading && <CustomLoader />
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  localHistory: state.history.localHistory,
  data: state.dashboard.member.data,
  currentPrice: state.dashboard.member.currentPrice,
  fundName: state.dashboard.member.fundName,
});

const mapDispatchToProps = {
  setAlertMessage: authActions.setAlertMessage,
  setMemberDashboardValues: dashboardActions.setMemberDashboardValues,
  setHistory: historyActions.setHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(MemberDashboard);
